import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import config from '../../../../../../config';
import { useOrganisationData } from '../../../../../Hooks/useOrganisation';
import { useUserInfoData } from '../../../../../Hooks/useUserInfo';
import useProjectInfoContext from '../../../../ProjectContexts/ProjectInfoContext/useProjectInfoContext';

export default function useAssistant() {
  const project = useProjectInfoContext();
  const org = useOrganisationData();
  const user = useUserInfoData();

  const enabled = React.useMemo(() => {
    const feature = org.features.cogneedAi?.liveAssistant;
    if (feature && feature.enabled) {
      if (!feature.staffOnly) { return true; }
      if (user.isStaff) return true;
    }
    return false;
  }, [org, user]);

  const assistantConfig = React.useMemo(() => project.project?.assistantConfig, [project.project]);

  const tagUrl = React.useMemo(() => {
    if (assistantConfig?.assistantId) {
      return `${config.ContentGeneration.AssistantTagUrl}/${user.organisationId.replace(' ', '%20')}/tags/${assistantConfig.assistantId}`;
    }
    return null;
  }, [assistantConfig?.assistantId, user.organisationId]);

  React.useEffect(() => {
    if (enabled && tagUrl) {
      const id = uuidv4();

      const elem = document.createElement('script');
      elem.id = `cogneed-chat-${id}-preview`;
      elem.src = tagUrl;
      document.body.appendChild(elem);

      const observer = new MutationObserver(() => {
        const iframes = document.querySelectorAll('iframe#custom-chat-widget-iframe');
        if (iframes.length > 0) {
          iframes.forEach((i) => {
            const iframeElem = i as HTMLIFrameElement;
            iframeElem.style.bottom = '85px';
            iframeElem.style.right = '15px';
          });
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      const deleteCallback = () => {
        document.getElementById(`cogneed-chat-${id}`)?.remove();
        document.getElementById('custom-chat-widget')?.remove();
        const iframes = document.querySelectorAll('iframe#custom-chat-widget-iframe');
        iframes.forEach((iframe) => iframe.remove());
      };
      return deleteCallback;
    }
    return undefined;
  }, [enabled, tagUrl]);
}
